export default __webpack_public_path__ + "static/media/effect-4096.bea0871d.mp3";